
<a
  :href="page.slug"
  :class="{ 'is-active': active }"
  class="navbar-item"
>
  {{ page.name }}
</a>
